<template>
  <div class="coupon-skeleton">
    <SkeletonAnimation>
      <div class="title">
        <div class="title-text"></div>
      </div>
      <div class="desc">
        <div class="desc-text"></div>
      </div>
      <div v-for="item in 5" :key="item" class="coupon-lists">
        <div class="list-left">
          <div class="round"></div>
          <div class="list-left-flex">
            <div>
              <div class="block1"></div>
            </div>
            <div>
              <div class="block2"></div>
              <div class="block3"></div>
            </div>
          </div>
          <div class="block4"></div>
        </div>
        <div class="list-right">
          <div class="round"></div>
        </div>
      </div>
    </SkeletonAnimation>
  </div>
</template>
<script>
import SkeletonAnimation from '../../SkeletonAnimation';
export default {
  name: 'CouponSkeletonH5',
  components: {
    SkeletonAnimation,
  },
};
</script>
<style lang="scss" scoped>
.coupon-skeleton {
  margin: 0 auto;
  padding: rem(20) rem(24);
}
.skeleton-bg {
  background: #e5e5eb;
}
.title {
  height: rem(116);
  background: #ffffff;
  border-radius: rem(12);
  padding: rem(40) rem(32);
}
.title-text {
  width: rem(238);
  height: rem(36);
  border-radius: rem(4);
  @extend .skeleton-bg;
}

.desc-text {
  border-radius: rem(4);
  width: rem(251);
  height: rem(28);
  @extend .skeleton-bg;
  margin: rem(20) rem(32) rem(32);
}
.coupon-lists {
  margin-bottom: rem(13);
  height: rem(258);
  border-radius: rem(12);
  display: flex;
  overflow: hidden;
}
.list-left {
  width: rem(432);
  background: #fff;
  position: relative;
  padding: rem(40) 0 0 rem(32);
  .round {
    width: rem(30);
    height: rem(30);
    background: #f5f5f5;
    border-radius: 50%;
    position: absolute;
    left: rem(-15);
    top: 50%;
    transform: translateY(-50%);
  }
}
.list-right {
  flex: 1;
  background: #fffbf9;
  position: relative;
  .round {
    width: rem(30);
    height: rem(30);
    background: #f5f5f5;
    border-radius: 50%;
    position: absolute;
    right: rem(-15);
    top: 50%;
    transform: translateY(-50%);
  }
}
.list-left-flex {
  display: flex;
  margin-bottom: rem(20);
  .block1 {
    width: rem(72);
    height: rem(72);
    @extend .skeleton-bg;
    margin-right: rem(20);
    border-radius: rem(4);
  }
  .block2 {
    height: rem(32);
    width: rem(260);
    @extend .skeleton-bg;
    border-radius: rem(4);
    margin-bottom: rem(8);
  }
  .block3 {
    height: rem(32);
    @extend .skeleton-bg;
    border-radius: rem(4);
    width: rem(160);
  }
}
.block4 {
  height: rem(28);
  width: rem(252);
  @extend .skeleton-bg;
  border-radius: rem(4);
  margin-top: rem(20);
}
</style>
